<div class="indexation-report-header">
  <button class="btn btn-primary" (click)="getIndexationReport()">
    Refresh
  </button>
</div>

<div class="indexation-report">
  <div class="indexation-report-item">
    <h2>Announcement Indexation</h2>
    <p>Total partitions: {{ indexationReport.announcement.partitions }}</p>
    <p>
      Success Indexed:
      {{ indexationReport.announcement.successIndexationCount }}
    </p>
    <p>
      Failed Indexed: {{ indexationReport.announcement.failedIndexationCount }}
    </p>
    <p>
      Todo Indexation: {{ indexationReport.announcement.todoIndexationCount }}
    </p>
  </div>
  <div class="indexation-report-item">
    <h2>Jobseeker Indexation</h2>
    <p>Total partitions: {{ indexationReport.jobseeker.partitions }}</p>
    <p>
      Success Indexed: {{ indexationReport.jobseeker.successIndexationCount }}
    </p>
    <p>
      Failed Indexed: {{ indexationReport.jobseeker.failedIndexationCount }}
    </p>
    <p>Todo Indexation: {{ indexationReport.jobseeker.todoIndexationCount }}</p>
  </div>
  <div class="indexation-report-item">
    <h2>Customer Indexation</h2>
    <p>Total partitions: {{ indexationReport.customer.partitions }}</p>
    <p>
      Success Indexed: {{ indexationReport.customer.successIndexationCount }}
    </p>
    <p>Failed Indexed: {{ indexationReport.customer.failedIndexationCount }}</p>
    <p>Todo Indexation: {{ indexationReport.customer.todoIndexationCount }}</p>
  </div>
  <div class="indexation-report-item">
    <h2>Transaction Indexation</h2>
    <p>Total partitions: {{ indexationReport.transaction.partitions }}</p>
    <p>
      Success Indexed: {{ indexationReport.transaction.successIndexationCount }}
    </p>
    <p>
      Failed Indexed: {{ indexationReport.transaction.failedIndexationCount }}
    </p>
    <p>
      Todo Indexation: {{ indexationReport.transaction.todoIndexationCount }}
    </p>
  </div>
</div>
